/** Локальный день как `YYYY-MM-DD`. */
export function dayKey(d: Date = new Date()): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function yesterdayKey(from: Date = new Date()): string {
  return dayKey(new Date(from.getTime() - 86_400_000))
}

/** Ключи с понедельника по воскресенье той недели, где лежит `from`. */
export function weekKeys(from: Date = new Date()): string[] {
  const monday = new Date(from)
  const shift = (from.getDay() + 6) % 7 // воскресенье === 0 → 6
  monday.setDate(from.getDate() - shift)
  monday.setHours(0, 0, 0, 0)
  return Array.from({ length: 7 }, (_, i) =>
    dayKey(new Date(monday.getTime() + i * 86_400_000)),
  )
}

/** Секунды как `м:сс`, а после часа — `ч:мм:сс`. */
export function formatDuration(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds))
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  const ss = String(s).padStart(2, '0')
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`
}

/** «сегодня» / «вчера» / «3 дня назад» — для ленты друзей. */
export function relativeDay(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''

  const key = dayKey(date)
  const today = dayKey()
  if (key === today) return 'сегодня'
  if (key === yesterdayKey()) return 'вчера'

  const days = Math.max(2, Math.round((Date.parse(today) - Date.parse(key)) / 86_400_000))
  if (days > 30) return 'давно'

  const m10 = days % 10
  const m100 = days % 100
  const word = m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? 'дня' : 'дней'

  return `${days} ${word} назад`
}
